var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M15 41h7v-2h-7z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 38c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM23.445 31.833l-6-4 1.11-1.665 6 4-1.11 1.665",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM26 14c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M30.168 24.555l-4-6 1.664-1.109 4 6-1.664 1.109M58 41h7v-2h-7z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 38c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM56.555 31.833l-1.11-1.665 6-4 1.11 1.665-6 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 24c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM54 14c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM39 22h2v-7h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M49.832 24.555l-1.664-1.109 4-6 1.664 1.109-4 6M40 10c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM61.445 53.833l-6-4 1.11-1.665 6 4-1.11 1.665",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 52c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM54 62c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M52.168 62.555l-4-6 1.664-1.109 4 6-1.664 1.109M18.555 53.833l-1.11-1.665 6-4 1.11 1.665-6 4",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 52c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM26 62c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM39 65h2v-7h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M27.832 62.555l-1.664-1.109 4-6 1.664 1.109-4 6M40 66c-1.103 0-2 .897-2 2 0 1.104.897 2 2 2s2-.896 2-2c0-1.103-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26c-7.72 0-14 6.281-14 14 0 7.72 6.28 14 14 14s14-6.28 14-14c0-7.719-6.28-14-14-14zM24 40c0-8.822 7.178-16 16-16s16 7.178 16 16c0 8.823-7.178 16-16 16s-16-7.177-16-16z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M25 41h30v-2H25zM28 32h24v-2H28zM28 50h24v-2H28z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26c-3.794 0-7 6.412-7 14 0 7.589 3.206 14 7 14s7-6.411 7-14c0-7.588-3.206-14-7-14zm0 30c-5.047 0-9-7.027-9-16 0-8.972 3.953-16 9-16 5.047 0 9 7.028 9 16 0 8.973-3.953 16-9 16z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M39 55h2V25h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }))));
}

export default SvgIconIllustrationGlobal;